import React from 'react'
import BranchUpdate from '../branch_components/branch_update'

export default function Main() {
  return <BranchUpdate />
}
